const EntityHeader = ({ metaInfo, dashboardType, title }) => {
  return (
    <div className="d-flex align-items-end">
      <h4 className="text-muted mb-3">{title}</h4>
      {dashboardType === "institutions" && metaInfo?.rorId && (
        <p className="mb-3 ms-2">
          (ROR ID:{" "}
          <a href={metaInfo.rorLink} target="_blank" rel="noopener noreferrer">
            {metaInfo.rorId}
          </a>
          )
        </p>
      )}
    </div>
  );
};

export default EntityHeader;
